import { AppState } from '@/store';
import Asset from '@components/tailwind/Asset';
import AssetGroup from '@components/tailwind/AssetGroup';
import usePartnerAssetGroups from '@features/partner/hooks/usePartnerAssetGroups';
import { selectAsset } from '@features/partner/redux/partner.actions';
import DesignGridWrapper from '@features/pdp/components/DesignGridWrapper';
import { Disclosure, Transition } from '@headlessui/react';
import { PartnerActionTypes, TAsset, TAssetGroup } from '@types';
import classNames from 'classnames';
import { useState } from 'react';
import { BsChevronRight } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';

const Designs = ({ rel }) => {
  const dispatch = useAppDispatch();
  const {
    partnerData: {
      partner: { galleryUrl, title },
      assetGroups,
      assets,
    },
    activeAsset,
  } = useSelector((state: AppState) => state.partner);
  const { activeGroup, selectGroup, flattenAssets, level } = usePartnerAssetGroups({
    activeAsset,
    assetGroups,
    assets: assets,
  });

  const selectAssetHandler = (asset: TAsset) => () => {
    dispatch(selectAsset(asset));
  };

  const selectGroupHandler = (group: TAssetGroup) => () => {
    dispatch({ type: PartnerActionTypes.SET_ACTIVE_GROUP, payload: group });
    selectGroup(group)();
  };

  return (
    <div className='tw-mb-10'>
      <div className='tw-mb-3 tw-flex tw-w-full tw-items-center tw-gap-2 tw-border-b tw-border-gray-300 tw-pb-3 md:tw-gap-3'>
        {(activeGroup?.assetGroup?.previewUrl || galleryUrl) && (
          <img
            src={activeGroup?.assetGroup?.previewUrl || galleryUrl}
            alt={`${title} Design Gallery Logo`}
            className='tw-max-h-7'
          />
        )}
        <p className='tw-mb-0 tw-text-base tw-font-bold'>
          {activeGroup?.assetGroup?.groupName?.toUpperCase() ?? <>DESIGN GALLERY</>}
        </p>
      </div>

      <div>
        <DesignGridWrapper maxHeight='280px' className='tw-py-3 tw-px-1'>
          {!!activeGroup && activeGroup.groups.length > 0 && (
            <div className='tw-mb-5 tw-flex tw-flex-col tw-justify-center tw-gap-4 md:tw-justify-start'>
              {activeGroup.groups.map((group) => (
                <AssetGroup
                  key={group.id}
                  text={group.groupName}
                  imageUrl={group.previewUrl}
                  onClick={selectGroupHandler(group)}
                />
              ))}
            </div>
          )}

          {!!activeGroup && activeGroup.assets.length > 0 && (
            <div className='tw-mb-5 tw-flex tw-flex-wrap tw-justify-center tw-gap-4 md:tw-justify-start'>
              {activeGroup.assets.map((asset) => (
                <Asset
                  key={asset.id}
                  asset={asset}
                  onClick={selectAssetHandler(asset)}
                  selected={asset.id === activeAsset?.id}
                />
              ))}
            </div>
          )}
        </DesignGridWrapper>

        {activeGroup.prevAssetGroup && (
          <div className='tw-my-3'>
            <AssetGroup
              key={activeGroup.assetGroup.id}
              text={activeGroup?.prevAssetGroup?.groupName || 'DESIGN GALLERY'}
              imageUrl={activeGroup?.prevAssetGroup?.previewUrl || galleryUrl}
              onClick={selectGroupHandler(activeGroup.prevAssetGroup)}
              isPrev
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Designs;
